/**
 * Site configuration — update these with your actual URLs and contact details
 */
export const config = {
  whatsapp: "https://wa.me/447731868223",
  whatsappCatalog: "https://wa.me/c/447731868223",
  instagram: "https://www.instagram.com/thefloralmuse888/",
  // WeChat has no public profile-URL scheme — `wechat.me/<id>` is a
  // myth, the official app uses QR codes / "add by ID" only. We expose
  // `wechatId` for the copy-to-clipboard buttons (Header, Footer, order
  // pay-page, email confirmation) and avoid emitting a fake URL in
  // schema.org `sameAs` arrays where it would be a broken SEO signal.
  wechatId: "Thefloralmuse888",
  xiaohongshu: "https://www.xiaohongshu.com/user/profile/5c1e32c800000000050329df",
  facebook: "https://www.facebook.com/TheFloralMuseLeeds",
  tiktok: "https://www.tiktok.com/@thefloralmuse888",
  pinterest: "https://uk.pinterest.com/thefloralmuse888/",

  googleBusinessUrl: "https://share.google/eHLPkbCawdjhOnHp2",

  // Stable Google Maps entity URL for the GBP listing (Knowledge Graph id
  // /g/11yybwf0z6) — used as the LocalBusiness `hasMap` in lib/seo.ts.
  googleMapsUrl: "https://www.google.com/maps?kgmid=/g/11yybwf0z6",

  // Official GBP "Ask for reviews" short link (Business Profile → Ask for
  // reviews) — opens the review dialog directly. Preferred over the long
  // `search.google.com/local/writereview?placeid=…` form for emails/QR codes.
  // VERIFIED 2026-07-08: 302s to search.google.com/local/writereview?placeid=
  // ChIJnY2wCpxfeUgRJI4v4lMFzeU (the real review form). An earlier token
  // (…3IEBM) was a transcription error that bounced to google.com's homepage —
  // guarded by tests/unit/lib/config.spec.ts.
  googleReviewUrl: "https://g.page/r/CSSOL-JTBc3lEAI/review",

  /** Public Trustpilot profile (review page) — linked from the footer. Only a
   *  link-out CTA: Trustpilot's free plan does NOT include a rating/review-text
   *  widget (both need a paid plan), so we never render Trustpilot content on
   *  site — just point customers here to leave a review. */
  trustpilotUrl: "https://www.trustpilot.com/review/thefloralmuse.uk",

  /**
   * Featurable widget id — the FALLBACK source for the Google review wall on
   * /reviews (the PRIMARY is the Google Business Profile API, lib/google-reviews.ts).
   * Pulls PUBLISHED Google reviews for free (Featurable's free plan is unlimited
   * page views) without needing per-project API approval — so reviews still show
   * while the Business Profile API access request is pending (quota 0). Once the
   * Business Profile API is live it takes precedence and this is never reached.
   *
   * NOT a secret: the same id is exposed in Featurable's public embed, so it's
   * safe in source (like `indexNowKey`). Empty string = fallback OFF. To enable:
   * create a free widget at featurable.com, connect the Google Business Profile,
   * and paste its widget id here — or set FEATURABLE_WIDGET_ID to override per
   * environment. Consumed server-side by lib/featurable.ts (so the fetch isn't
   * subject to the browser CSP, and review data is never cached against Google's
   * Places terms — Featurable hosts it).
   *
   * NOTE: real reviews only appear once the Google Business Profile is connected
   * in the Featurable dashboard — while unconnected the widget returns demo rows
   * (`isExampleReviews:true`), which lib/featurable.ts deliberately refuses to
   * show. This widget's GBP is connected (verified 2026-07-15: real reviews +
   * `gbpLocationSummary` rating/count live).
   */
  featurableWidgetId: "337d7570-c755-4025-a3a0-fb4c48c02dd8",

  /**
   * Trustpilot Automatic Feedback Service (AFS) BCC address. BCC'ing this on a
   * POST-FULFILMENT customer email makes Trustpilot invite that customer to
   * leave a review (it reads the To: address as the reviewer). Wired to the
   * dispatch email ONLY — never the order confirmation, which sends at order
   * placement before payment + delivery, when a review invite would be
   * premature (see lib/resend-orders.ts → getTrustpilotInviteBcc).
   *
   * NOT a secret: a per-account invite alias, safe in source (like the
   * IndexNow key below). IMPORTANT: set the invitation DELAY in the Trustpilot
   * dashboard (Settings → Invitations) so the invite lands a few days after
   * dispatch, i.e. after the order has actually arrived. Override or disable
   * per environment with the TRUSTPILOT_BCC env var ("" disables it).
   */
  trustpilotInviteBcc: "thefloralmuse.uk+dc850219f2@invite.trustpilot.com",

  siteUrl: "https://thefloralmuse.uk",

  /** Phone for contact in E.164 — used for `tel:` links and schema
   *  `telephone`. (No full address — online-only / service-area business.) */
  phone: "+447731868223",
  /** Human-friendly display form of `phone` (UK national format) shown to
   *  customers in the Footer + Enquire page. Keep in sync with `phone`. */
  phoneDisplay: "07731 868223",

  /**
   * The site-wide contact email — ALL inbound email routes here: enquire
   * page, privacy/terms/returns mailto links, JSON-LD `email` +
   * `contactPoint`, invoice footer, security.txt, and it's the default
   * Resend `from` (lib/resend-orders.ts), so customer replies land here too.
   * (Renamed from `privacyContactEmail` 2026-06-12 — it was always the
   * general contact address, not a GDPR-only one.)
   */
  contactEmail: "hello@thefloralmuse.uk",

  /**
   * Dedicated subdomain that receives the two-way inbox replies (its MX points
   * to Resend Inbound). Sends set Reply-To = reply+<token>@<replyDomain> so a
   * customer reply threads back without touching the apex/`hello@` mail flow.
   * Overridable via REPLY_INBOUND_DOMAIN. See lib/email-send.ts.
   */
  replyDomain: process.env.REPLY_INBOUND_DOMAIN || "reply.thefloralmuse.uk",

  /**
   * IndexNow key — used to instantly notify Bing/Yandex/Seznam/Naver/Yep
   * when products, events, or pages change (see lib/indexnow.ts). NOT a
   * secret: the same value is published at
   * `${siteUrl}/${indexNowKey}.txt` (public/<key>.txt) for ownership
   * verification, so it lives in plain config alongside siteUrl. To
   * rotate: generate a new key, rename the public/<key>.txt file to
   * match, and update this constant.
   */
  indexNowKey: "4068cc43916880998089dfde85217821",

  /**
   * Microsoft Clarity project ID — loads the Clarity analytics / session-
   * replay script (see components/analytics/MicrosoftClarity.tsx). Like the
   * GA measurement ID this is a PUBLIC client-side identifier, not a secret.
   * Loaded only after analytics cookie consent. Override per environment
   * with NEXT_PUBLIC_CLARITY_PROJECT_ID.
   */
  clarityProjectId: "x07n1k75d4",

  /**
   * Google Customer Reviews merchant id (the Google Merchant Center account
   * id). PUBLIC client-side identifier — not a secret (same class as the GA
   * measurement id and the Clarity project id above). Powers the post-purchase
   * GCR survey opt-in on /order/[code] (see
   * components/analytics/GoogleCustomerReviews.tsx). Override per environment
   * with NEXT_PUBLIC_GOOGLE_MERCHANT_ID.
   */
  googleMerchantId: "5740605495",

  /**
   * Chinese payment methods (Alipay 支付宝 / WeChat Pay 微信支付 / UnionPay 银联).
   * These are enabled in the STRIPE DASHBOARD (Settings → Payment methods) — the
   * hosted Checkout renders them automatically because lib/stripe.ts omits
   * `payment_method_types` (uses Stripe's automatic payment methods). This flag
   * ONLY controls whether the /zh pages show the "支持支付宝/微信支付/银联" trust
   * badges. Keep it FALSE until the methods are actually live in Stripe, so we
   * never advertise a payment method we can't accept. Flip to true after
   * enabling them in the Stripe Dashboard (and confirming they render for GBP).
   */
  chinesePaymentMethods: false,
};
